import { render, staticRenderFns } from "./RatingPieChart.vue?vue&type=template&id=ca476d94&"
import script from "./RatingPieChart.vue?vue&type=script&lang=js&"
export * from "./RatingPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports